import {TConversationCountry} from '../definitions';

const MAX_DECIMAL_SCALE = 4;

type TFormData = {
  mauCount: number;
  initPayment: number;
  licensePrice: number;
  defaultMauPrice: number;
  conversationCountryScaleList: TConversationCountry[];
};

export type {TFormData};
export {MAX_DECIMAL_SCALE};
